import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

const CustomCursor = () => {
    // 1. Direct Mouse Values (Instant 1:1 tracking)
    const mouseX = useMotionValue(-100);
    const mouseY = useMotionValue(-100);

    // 2. Smooth "Trailer" Values (Physics-based)
    // REMOVED Spring for instant unified movement as requested
    // "make both thing togather there is delay between tham"

    const [isHovering, setIsHovering] = useState(false);

    useEffect(() => {
        const mouseMove = (e) => {
            // Update raw values immediately
            mouseX.set(e.clientX);
            mouseY.set(e.clientY);
        };

        const mouseOver = (e) => {
            const target = e.target;
            const isClickable = target.closest('a') || target.closest('button') || target.closest('[role="button"]');
            setIsHovering(!!isClickable);
        };

        window.addEventListener("mousemove", mouseMove);
        window.addEventListener("mouseover", mouseOver);

        return () => {
            window.removeEventListener("mousemove", mouseMove);
            window.removeEventListener("mouseover", mouseOver);
        };
    }, [mouseX, mouseY]);

    return (
        <>
            {/* 1. Main Dot */}
            <motion.div
                className="fixed top-0 left-0 z-[9999] pointer-events-none mix-blend-difference bg-white rounded-full hidden md:block"
                style={{
                    x: mouseX,
                    y: mouseY,
                    translateX: "-50%",
                    translateY: "-50%",
                }}
                animate={{
                    width: isHovering ? 8 : 8,
                    height: isHovering ? 8 : 8,
                }}
            />

            {/* 2. Ring: Now moves instantly with Dot (Unified) */}
            <motion.div
                className="fixed top-0 left-0 z-[9998] pointer-events-none mix-blend-difference border border-white rounded-full hidden md:block"
                style={{
                    x: mouseX, // Directly use mouseX (no trailer spring)
                    y: mouseY, // Directly use mouseY
                    translateX: "-50%",
                    translateY: "-50%",
                }}
                animate={{
                    width: isHovering ? 48 : 24,
                    height: isHovering ? 48 : 24,
                    opacity: isHovering ? 0.8 : 0.5,
                    borderWidth: isHovering ? "2px" : "1px",
                }}
                transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 20
                }}
            />
        </>
    );
};

export default CustomCursor;
